module.exports = __webpack_public_path__ + "static/media/33.7f68a336.mp3";